package ai.flowstorm.studio.ui.design

import ai.flowstorm.common.state.Stateful
import ai.flowstorm.common.state.StatefulValue
import ai.flowstorm.common.ui.DeferredModal
import ai.flowstorm.studio.model.CodeDebug
import ai.flowstorm.studio.resources.CodeDebugResource
import io.kvision.form.text.TextArea
import io.kvision.html.*
import io.kvision.i18n.tr
import io.kvision.modal.ModalSize
import io.kvision.panel.hPanel
import io.kvision.state.bind
import io.kvision.utils.px
import kotlinx.coroutines.*

class CodeDebugModal(code: String) : DeferredModal<List<String>>(caption = tr("Code Debugger"), size = ModalSize.XLARGE),
    Stateful<CodeDebugModal.State> by StatefulValue(State()) {

    data class State(
        val loading: Boolean = false
    )

    private var output = ""
    private val mainScope = MainScope()



    private var codeEditor = ModelCodeEditor().apply {
        set(code)
        readOnly = true
    }

    private var outputText = TextArea {
        //label = tr("Output")

        bind(this@CodeDebugModal) {
            readonly = true
            value = if (it.loading) "Loading ..." else output
        }
    }

    init {
        hPanel(className = "alternatives-modal") {
            spacing = 4
            padding = 4.px
            //height = 5.em

            add(codeEditor)
        }
        b {
            paddingTop = 4.px
            paddingLeft = 4.px
            paddingRight = 4.px
            content = io.kvision.i18n.tr("Warning:")
        }
        div {
            paddingBottom = 4.px
            paddingLeft = 4.px
            paddingRight = 4.px
            content = io.kvision.i18n.tr("Please take the debugger outputs with a grain of salt. They should be used as an additional source of information only. The debugger may have errors with transitions to next nodes, by turn, by session, and by user attributes. Additionally, it may suggest unnecessary code imports. Please use your best judgement and carefully evaluate the suggested solutions.")
        }
        hPanel(className = "alternatives-modal") {
            spacing = 4
            padding = 4.px

            add(outputText)
        }
    }

    fun cancel() {
        hide()
    }

    override suspend fun open(): List<String> = coroutineScope {
        show()
        deferred = CompletableDeferred(coroutineContext[Job])

        launch {
            newState { copy(loading = true) }
            output = CodeDebugResource.debugCode(CodeDebug(prompt="Debug this Kotlin code and describe errors of original code and explain the changes you made:",code = codeEditor.value)).debug
            newState { copy(loading = false) }
        }

        deferred.await()
    }
}
